import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getRequirementList = (payload, callback) => req.list(
  c.GET_REQUIREMENT,
  'api/v1/administrators/requirements',
  payload,
  callback,
);

export const showRequirement = (id, payload, callback) => req.item(
  c.GET_SINGLE_REQUIREMENT,
  `api/v1/administrators/requirements/${id}`,
  payload,
  callback,
);

export const createRequirement = (payload, callback) => req.create(
  c.CREATE_REQUIREMENT,
  'api/v1/administrators/requirements',
  payload,
  ({ res }) => {
    const { data } = res.res;
    if (callback) callback({ data });
  },
);

export const updateRequirement = (id, payload, callback) => req.update(
  c.UPDATE_REQUIREMENT,
  `api/v1/administrators/requirements/${id}`,
  payload,
  ({ res }) => {
    const { data } = res.res;
    if (callback) callback({ data });
  },
);

export const removeRequirement = (id, payload, callback) => req.remove(
  c.REMOVE_REQUIREMENT,
  `api/v1/administrators/requirements/${id}`,
  payload,
  (res) => {
    const { message } = res.res;
    alert.success(message || 'Successfully Untag !');
    if (callback) callback();
  },
);

export const getTag = (payload, callback) => req.list(
  c.GET_TAG,
  'api/v1/administrators/application_status_requirements',
  payload,
  callback,
);

export const getApplicationStatus = (payload, callback) => req.list(
  c.GET_APPLICATION_STATUS,
  'api/v1/administrators/module_systems/1/application_statuses',
  payload,
  callback,
);

export const TagRequire = (payload, callback) => req.create(
  c.TAG,
  'api/v1/administrators/application_status_requirements',
  payload,
  (res) => {
    const { message } = res.res;
    alert.success(message || 'Successfully tagged your Requirement!');
    if (callback) callback();
  },
);

export const removeTag = (id, payload, callback) => req.remove(
  c.REMOVE_TAG,
  `api/v1/administrators/application_status_requirements/${id}`,
  payload,
  (res) => {
    const { message } = res.res;
    alert.success(message || 'Successfully remove your tagged Requirement!');
    if (callback) callback();
  },
);
